<!--
    描述：聚易厅项目列表
    Created by wangh  2022-03-29
    routeQuery:
        projectAuditMsg: 审核，审核不通过查看
        projectViewMsg：查看详情，多个tab页(项目基本信息，投标人/投标保证金，项目合同，项目进度更新，项目成过验收，项目佣金发放，项目开票，雇主方评价)
-->
<template>
	<div class="h100 audit operation-layout"
		 :class="{ sHeight: routeQuery == 'projectAuditMsg' || routeQuery == 'projectViewMsg' }">
		<div class="header"
			 v-if="!routeQuery">
			<el-row>
				<div class="searchBox"
					 v-if="searchToggle">
					<el-form :model="searchForm"
							 label-width="120px"
							 size="small">
						<el-row>
							<el-col :span="7">
								<el-form-item label="项目名称：">
									<el-input v-model="searchForm.sname"
											  clearable
											  placeholder="请输入"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item label="项目标签：">
									<el-select v-model="searchForm.projectLevel"
											   clearable>
										<el-option v-for="(item, index) in projectLevelList"
												   :key="'项目标签' + index"
												   :label="item.sname"
												   :value="item.value"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item label="创建人：">
									<el-input v-model="searchForm.publisherName"
											  clearable
											  placeholder="请输入项目创建单位名称或个人姓名"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="7">
								<el-form-item label="创建时间：">
									<!-- :picker-options="startDatePicker" -->
									<el-col :span="11">
										<el-date-picker v-model="searchForm.createStartDate"
														type="date"
														placeholder="开始时间"
														value-format="yyyy-MM-dd"
														clearable
														>
										</el-date-picker>
									</el-col>
									<el-col :span="2"
											class="text-center">~</el-col>
									<el-col :span="11">
												<!-- :picker-options="endDatePicker" -->
										<el-date-picker v-model="searchForm.createEndDate"
														type="date"
														placeholder="截止时间"
														value-format="yyyy-MM-dd"
														clearable
												>
										</el-date-picker>
									</el-col>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item label="发布时间：">
									<el-col :span="11">
										<!-- :picker-options="startSendDatePicker" -->
										<el-date-picker v-model="searchForm.sendStartDate"
														type="date"
														placeholder="开始时间"
														value-format="yyyy-MM-dd"
														clearable
														>
										</el-date-picker>
									</el-col>
									<el-col :span="2"
											class="text-center">~</el-col>
									<el-col :span="11">
										<!-- :picker-options="endSendDatePicker" -->
										<el-date-picker v-model="searchForm.sendEndDate"
														type="date"
														placeholder="截止时间"
														value-format="yyyy-MM-dd"
														clearable
														>
										</el-date-picker>
									</el-col>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item label-width="40px">
									<el-button type="primary"
											   class="btn-blue"
											   size="small"
											   @click="searchName">搜索
									</el-button>
									<el-button type="warning"
											   size="small"
											   @click="reset">重置
									</el-button>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
				<el-col :span="24"
						class="toolbar mt20">
					<el-tabs v-model="typeState"
							 @tab-click="tabChange(typeState)">
						<el-tab-pane name="4">
							<span slot="label">全部
								<el-badge :value="allNum"
										  class="item"></el-badge>
							</span>
						</el-tab-pane>
						<el-tab-pane name="0">
							<span slot="label">进行中
								<el-badge :value="normalNum"
										  class="item"></el-badge>
							</span>
						</el-tab-pane>
						<el-tab-pane name="2">
							<span slot="label">已结束
								<el-badge :value="endNum"
										  class="item">
								</el-badge>
							</span>
						</el-tab-pane>
						<el-tab-pane name="3">
							<span slot="label">异常终止
								<el-badge :value="abnormalEndNum"
										  class="item">
								</el-badge>
							</span>
						</el-tab-pane>
					</el-tabs>
					<div class="toolbar-right">
						<el-button type="primary"
								   class="btn-blue ml10"
								   size="small"
								   @click="changeState">
							筛选
							<i v-if="searchToggle"
							   class="el-icon-caret-bottom ml5"></i>
							<i v-else
							   class="el-icon-caret-top ml5"></i>
						</el-button>
						<el-button type="primary"
								   class="btn-blue ml10"
								   icon="el-icon-refresh"
								   @click="reset"
								   size="small"></el-button>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="operation-main">
			<!-- 非请求参数 正常查看 -->
			<div class="w-table-layout w-table-page"
				 v-if="!routeQuery">
				<div class="w-table-content"
					 v-show="tableShow">
					<el-table :data="filiterData"
							  height="100%"
							  highlight-current-row
							  row-key="id"
							  border
							  ref="table">
						<el-table-column type="index"
										 label="序号"
										 align="center"
										 width="50"></el-table-column>
						<el-table-column prop="sname"
										 label="项目名称"
										 header-align="center"
										 min-width="150"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="projectLevelName"
										 label="项目标签"
										 header-align="center"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="projectTypeName"
										 label="项目类型"
										 align="center"
										 width="140"
										 show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="publisherName"
										 label="项目创建人"
										 header-align="center"
										 min-width="140"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="bidMode"
										 label="竞价模式"
										 align="center"
										 width="110"
										 show-overflow-tooltip>
							<template slot-scope="scope">
								<span>{{ scope.row.bidMode == 0 ? '一口价模式' : '可议价模式' }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="allowBids"
										 label="允许报名人数"
										 width="110"
										 align="center"
										 show-overflow-tooltip>
							<template slot-scope="scope">
								<span>{{ scope.row.allowBids ? scope.row.allowBids + '人' : '' }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="employerOffer"
										 label="雇主报价"
										 header-align="center"
										 align="center"
										 width="140"
										 show-overflow-tooltip>
							<template slot-scope="scope">
								<span>{{ scope.row.employerOffer ? scope.row.employerOffer.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') + '元' : '' }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="depositFlag"
										 label="是否需要投标保证金"
										 width="150"
										 align="center"
										 show-overflow-tooltip>
							<template slot-scope="scope">
								<span>{{ scope.row.depositFlag === 0 ? '否' : '是' }}</span>
							</template>
						</el-table-column>
						<el-table-column header-align="center"
										 align="center"
										 prop="registrationDeadline"
										 label="报名截止时间"
										 width="130"
										 show-overflow-tooltip>
							<template slot-scope="scope">
								<!-- <span :class="{colorred:scope.row.registrationDeadlineType =='已截止'}">{{ scope.row.registrationDeadlineType !=="已截止" ? scope.row.registrationDeadlineType.substring(0, 16) : scope.row.registrationDeadlineType }}</span> -->
									<span :class="{colorred:scope.row.registrationDeadlineType =='已截止'}">{{ scope.row.registrationDeadlineType !=="已截止" ? scope.row.registrationDeadline.substring(0, 16) : scope.row.registrationDeadlineType }}</span>
							</template>
						</el-table-column>
						<el-table-column header-align="center"
										 align="center"
										 prop="createDate"
										 width="110"
										 label="项目创建时间"
										 show-overflow-tooltip>
							<template slot-scope="scope">
								<span>{{ scope.row.createDate ? scope.row.createDate.substring(0, 10) : '' }}</span>
							</template>
						</el-table-column>
						<el-table-column header-align="center"
										 align="center"
										 prop="sendTime"
										 label="发布时间"
										 width="110"
										 show-overflow-tooltip>
							<template slot-scope="scope">
								<span>{{scope.row.sendTime.substring(0, 10)  }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="isFlag"
										 label="状态"
										 width="100"
										 align="center"
										 :resizable="false"
										 show-overflow-tooltip>
							<template slot-scope="scope">
								<span :class="dealClass(scope.row.isFlag)">{{scope.row.isFlag | isFlagFilter }}</span>
							</template>
						</el-table-column>
						<el-table-column align="center"
										 width="110">
							<template slot="header">操作</template>
							<template slot-scope="scope">

								<el-button type="primary"
										   size="small"
										   round
										   plain
										   class="table-btn"
										   @click="audit(scope.row)">
									<svg-icon icon-class="form-look"></svg-icon> 查看详情
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="w-table-footer"
					 v-if="!routeQuery">
					<el-pagination @size-change="handleSizeChange"
								   @current-change="handleCurrentChange"
								   :current-page="currentPage"
								   :page-sizes="pageList"
								   :page-size="pageSize"
								   :total="total"
								   layout="total, sizes, prev, pager, next, jumper">
					</el-pagination>
				</div>
			</div>

			<!--查看、审核 安招采-->
			<!-- :isDisabled="this.$route.query.mode"
							@openDia="openDia" :audit="isAudit" -->
			<juyi-pro-audit v-if="routeQuery == 'projectAuditMsg'"
							ref="childContent"
							:rowData="rowData"></juyi-pro-audit>

		</div>

	</div>
</template>

<script>
import { mapState } from 'vuex';
import { selectPageNum, auditProjectForJuyi, selectPageList } from 'api/modules/projectManagement';
import JuyiProAudit from './components/juyi-pro-audit'

export default {
	name: "juyi-project-list",
	components: { JuyiProAudit },
	data() {
		return {
			typeState: '4',
			//标签红点
			allNum: 0,  //全部
			normalNum: 0,  //进行中
			endNum: 0,  //已结束
			abnormalEndNum: 0,//异常终止
			filiterData: [],
			loading: false,
			//筛选框
			searchForm: {
				type: '',//0.正常(进行中) 1.取消  2.已结束  3.异常终止；全部，传个空；
				sname: '', //项目标题
				projectLevel: '',//项目标签
				projectType: '', //项目类型
				publisherName: '',//申请方
				createStartDate: '', //申请开始时间
				createEndDate: '', //申请结束时间
				sendStartDate: '',//发布开始时间
				sendEndDate: '',//发布结束时间
				// scope: '009',//聚易厅对应字段码

			},
			xmbql: [],//项目标签下拉数据
			auditState: '0',
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			auditShow: false, // 审核弹窗的显隐
			checkForm: {
				isVerify: '', //审核结果
				updateUserid: '', //当前用户id
				id: '', //审核项id
				content: '', //审核意见
				projectLevel: ''
			},
			checkRule: {
				isVerify: [{ required: true, message: '审核结果不能为空' }],
				content: [{ required: true, message: '审核意见不能为空' }],
				projectLevel: [{ required: true, message: '项目资质不能为空' }]
			},
			dataType: '',
			auditProjectMsg: {}, // 用于接收专家审核传过来的参数
			rowData: {}, // 表格操作当前行数据
			// startDatePicker: this.beginDate(), //限制选择时间的开始
			// endDatePicker: this.processDate(), //限制选择时间的结束
			// startSendDatePicker: this.beginSendDate(),
			// endSendDatePicker: this.processSendDate(),
			certificateList: [
				{
					id: '',
				},
			], //证书列表
			searchToggle: true, //筛选控制
			tableShow: true, //表格显隐控制
			realNameLoading: false,
			isAudit: '',//是否为审核，是则展示审核按钮
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('activeTab')) {
				this.typeState = JSON.parse(this.$getSessionItem('activeTab'))
				// this.tabChange(this.typeState)

				// 移除 避免污染
				this.$removeSessionItem('activeTab')
			}

			if (this.$getSessionItem('params')) {
				this.searchForm = JSON.parse(this.$getSessionItem('params'))
				this.currentPage = JSON.parse(
					this.$getSessionItem('params')
				).current
				this.pageSize = JSON.parse(this.$getSessionItem('params')).size
				this.auditState = JSON.parse(
					this.$getSessionItem('params')
				).status

				// 移除 避免污染
				this.$removeSessionItem('params')
			}
		}
		this.getData()
		//查询标签数量
		this.getTabNum()
	},
	filters: {
		isFlagFilter(status) {
			const statusMap = {
				0: '进行中',
				2: '已结束',
				3: '异常终止',
				1: '已撤回'
			}
			return statusMap[status]
		},

	},
	methods: {
		// 处理状态
		dealClass(data) {
			let msg = ''
			switch (data) {
				case 0:
					msg = 'green-state'
					break
				case 1:
					msg = 'orange-state'
					break
				case 2:
					msg = 'gray-state'
					break
				case 3:
					msg = 'red-state'
					break
			}
			return msg
		},

		// 关闭loading
		realClose() {
			this.realNameLoading = false
		},

		// tab切换
		tabChange(val) {
			this.currentPage = 1
			this.pageSize = 10
			if (val == '4') {
				this.searchForm.type = ''
			} else {
				this.searchForm.type = val
			}
			this.getTabNum()
			this.getData()
		},

		// 搜索
		searchName() {
			this.pageSize = 10
			this.currentPage = 1
			this.getTabNum()
			this.getData()
		},

		//获取标签数量
		getTabNum() {
			selectPageNum({
				// scope: this.searchForm.scope
			}).then(res => {
				if (res.operationCode == 1) {
					this.allNum = parseInt(res.data.allNum)
					this.normalNum = parseInt(res.data.normalNum)
					this.endNum = parseInt(res.data.endNum)
					this.abnormalEndNum = parseInt(res.data.abnormalEndNum)
				}
			})
		},

		//获得列表数据
		getData(isBack) {
			let params = Object.assign({}, this.searchForm)
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			selectPageList(params).then(res => {
				if (res.operationCode == 1) {
					this.loading = false
					this.filiterData = res.data.records
					//this.filiterData = [{}]
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
				}
			})
		},

		//筛选框重置
		reset() {
			this.searchForm.sname = ''
			this.searchForm.projectLevel = ''
			// this.searchForm.projectType = ''
			this.searchForm.publisherName = ''
			this.searchForm.createStartDate = ''
			this.searchForm.createEndDate = ''
			this.searchForm.sendStartDate = ''
			this.searchForm.sendEndDate = ''
			this.pageSize = 10
			this.currentPage = 1
			this.getTabNum()
			this.getData()
		},

		// 点击审核
		audit(data, type) {
			let queryType = 'projectAuditMsg'; // 审核页面，支持审核及查看
			let params = Object.assign({}, this.searchForm)
			params.current = this.currentPage
			params.size = this.pageSize
			// params.status = this.auditState
			params.type = this.searchForm.type

			// 存值
			this.$setSessionItem('params', JSON.stringify(params))
			this.$setSessionItem('activeTab', JSON.stringify(this.typeState))

			// 列表数据
			this.rowData = data
			// if (type === 'audit') {
			// 	this.isAudit = type //标记为审核
			// } else if (data.isVerify === 3) {//审核不通过，查看页面为审核页面，无审核按钮
			// 	this.isAudit = type //标记为查看
			// } else { // 不满足上述条件，则项目正常，查看项目进度页面
			// 	this.isAudit = type //标记为查看
			// 	//queryType = 'projectViewMsg' //跳转页面至多tab的详情页
			// }

			// 页面跳转
			this.$router.push({
				name: 'juyi-project-list',
				query: {
					type: queryType,
					mode: type,
				},
			})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getTabNum()
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getTabNum()
			this.getData()
		},

		// 开始时间的 pickOption
		// beginDate() {
		// 	let that = this
		// 	return {
		// 		disabledDate(time) {
		// 			let endTime = ''
		// 			endTime = that.searchForm.createEndDate
		// 			if (endTime != '') {
		// 				// endTime = endTime.getTime() + 86400000
		// 			}
		// 			if (endTime) {
		// 				return bmElementTimeOptins.limitDateBefore(
		// 					time,
		// 					endTime,
		// 					true
		// 				)
		// 			} else {
		// 				return time.getTime() > Date.now()
		// 			}
		// 		},
		// 	}
		// },

		// 结束时间的 pickOption
		// processDate() {
		// 	let that = this
		// 	return {
		// 		disabledDate(time) {
		// 			let startTime = ''
		// 			startTime = that.searchForm.createStartDate
		// 			if (startTime) {
		// 				let nowTime = Date.now()
		// 				return bmElementTimeOptins.limitDateInRange(
		// 					time,
		// 					startTime,
		// 					nowTime,
		// 					true
		// 				)
		// 			} else {
		// 				return time.getTime() > Date.now()
		// 			}
		// 		},
		// 	}
		// },

		// 开始时间的 pickOption
		// beginSendDate() {
		// 	let that = this
		// 	return {
		// 		disabledDate(time) {
		// 			let endTime = ''
		// 			endTime = that.searchForm.sendEndDate
		// 			if (endTime != '') {
		// 				// endTime = endTime.getTime() + 86400000
		// 			}
		// 			if (endTime) {
		// 				return bmElementTimeOptins.limitDateBefore(
		// 					time,
		// 					endTime,
		// 					true
		// 				)
		// 			} else {
		// 				return time.getTime() > Date.now()
		// 			}
		// 		},
		// 	}
		// },
		// 结束时间的 pickOption
		// processSendDate() {
		// 	let that = this
		// 	return {
		// 		disabledDate(time) {
		// 			let startTime = ''
		// 			startTime = that.searchForm.sendStartDate
		// 			if (startTime) {
		// 				let nowTime = Date.now()
		// 				return bmElementTimeOptins.limitDateInRange(
		// 					time,
		// 					startTime,
		// 					nowTime,
		// 					true
		// 				)
		// 			} else {
		// 				return time.getTime() > Date.now()
		// 			}
		// 		},
		// 	}
		// },
		// 切换状态
		changeState() {
			this.searchToggle = !this.searchToggle
		},

	},
	computed: {
		...mapState('app', {
			clientSize: (state) => state.clientSize,
			isBack: (state) => state.isBack,
		}),

		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),

		...mapState('user', { userInfo: (state) => state.userInfo }),

		...mapState('dict', {
			projectLevelList: (state) => state.projectQualification
		}),

		routeQuery() {
			return this.$route.query.type
		},
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},

		// 监听路由参数 --- 回到主界面时刷新查询
		$route(params) {
			let arr = Object.keys(params.query)
			if (arr.length === 0) {
				this.getTabNum()
				this.getData()
			}
		},
	},
}
</script>

<style scoped lang="less">
.audit {
	.searchBox {
		padding-top: 8px;
	}
	/deep/ .more-layout {
		top: 55px;
		right: 370px;
	}
	/deep/ .el-tabs__item {
		width: 100px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		background: #f0f0f0;
		border-radius: 3px 3px 0px 0px;
		color: #666;
		margin-right: 20px;
		padding: 0;
		.el-tabs__header {
			border-bottom: 1px solid #2671cc;
		}
	}
	/deep/ .el-tabs__item.is-active {
		color: #fff;
		background-color: #2671cc !important;
	}
	/deep/ .el-tabs__nav-wrap::after {
		background-color: #2671cc;
		height: 1px;
		z-index: 999;
	}
	/deep/ .el-tabs__active-bar {
		background-color: transparent;
	}
	.auditMsg {
		color: #2671cc;
		cursor: pointer;
	}
	.green,
	.red,
	.orange {
		display: inline-block;
		height: 28px;
		line-height: 28px;
		padding: 0 10px;
		font-size: 12px;
		border-radius: 5px;
	}
	.green {
		background: #e9f6f2;
		border: 1px solid #bff5e5;
		color: #39c098;
	}
	.red {
		background: #feeff0;
		border: 1px solid #fde2e2;
		color: #f56c6c;
	}
	.orange {
		background: #fdf6ec;
		border: 1px solid #faecd8;
		color: #e7a23c;
	}
	.toolbar {
		position: relative;
		.toolbar-right {
			position: absolute;
			right: 0;
			top: 0;
		}
	}
	/deep/ .el-table__header-wrapper {
		tr > th {
			padding: 6px 0 !important;
			height: 50px !important;
		}
	}
	.item {
		position: absolute !important;
		right: -15px;
	}
}
.sHeight {
	padding: 0;
}
.colorred {
	color: #f56c6c;
}
</style>
